import { UserProviderInfoModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class UserProviderCalendarODataRepo extends BaseODataRepository<UserProviderInfoModel> {
  protected baseUrl = `/OData/calendarevent`;
}


